import React from 'react';
import styles from './FormulariContacte.module.scss';

export default function FormulariContacte() {
    return (
        <>
            <div className={styles.desplegable}>
                <div className={styles.texto}>
                    <div className={styles['R-formulariContacte']}>

                        <form action="https://www.3cat.cat/su/Register" method="post" name="peticio" acceptCharset="ISO-8859-1">

                         
                                <div>
                                    <label htmlFor="NOM" className={styles.required}>Nom</label>
                                    <input type="text" id="NOM" name="NOM" required="required" />
                                </div>
                                <div>
                                    <label label htmlFor="CORREU" className={styles.required}>Correu-e</label>
                                    <input type="email" id="CORREU" name="CORREU" required="required" />
                                </div>
                                <div>
                                    <label label htmlFor="TEXT" className={styles.required}>Missatge</label>
                                    <textarea name="TEXT" rows="2" id="TEXT" required="required"></textarea>
                                </div>
                         
                            <button>Envia</button>
                            <input type="hidden" name="hiTarget" value="/corporatiu/rs/contacte/ok/" />
                            <input type="hidden" name="hiErrTarget" value="/corporatiu/rs/contacte/ko/" />
                            <input type="hidden" name="hiRegServiceId" value="TVC_REG" />
                            <input type="hidden" name="hiAction" value="73" />
                            <input type="hidden" name="hiServiceId" value="RS_CONTACTE" />
                            <input type="hidden" name="from" value="no_reply@tv3.cat" />


                        </form>


                    </div>
                </div>
            </div>
        </>
    );
}
